import React from 'react'
import Box from '@mui/material/Box'
import { AUDIT_CHIP_VARIANTS, auditActionChipBaseSx } from './rbacAuditHistoryConstants'
import { getActionChipConfig } from './rbacAuditHistoryHelpers'

export default function RbacAuditActionChip({ entry, context }) {
  const config = getActionChipConfig(context, entry?.action)
  const colors = AUDIT_CHIP_VARIANTS[config.variant] || AUDIT_CHIP_VARIANTS.blue

  return (
    <Box
      component="span"
      sx={{
        ...auditActionChipBaseSx,
        backgroundColor: colors.backgroundColor,
        color: colors.color
      }}
    >
      {config.label}
    </Box>
  )
}
